import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import VideoPlayer from "./VideoPlayer";
const VideoPlayerPopup = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        className="icon-btn video-btn video video-popup"
        onClick={handleShow}
      >
        <i class="icofont-play-alt-2"></i>
      </Button>
      <Modal show={show} onHide={handleClose} className="v-player-modal-main">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <VideoPlayer />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VideoPlayerPopup;
